import { Component, inject, OnInit, signal } from '@angular/core';
import { QRISLY_DELIVERY_HISTORY, QRISLY_RESEND_WEBHOOK } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { DeliveryWebhookResponse, DeliveryWebhookResponseList } from 'src/app/types/response/webhook-response.type';

import { NzMessageService } from 'ng-zorro-antd/message';
import { ResponseCustomType } from 'src/app/types/response/response.type';

@Component({
  standalone: false,
  selector: 'app-delivery-webhook',
  templateUrl: './delivery-webhook.component.html',
  styleUrl: './delivery-webhook.component.scss'
})
export class DeliveryWebhookComponent implements OnInit {
  deliveryHistory: DeliveryWebhookResponse = {
    limit: 0,
    list: [],
    offset: 0,
    total: 0
  };

  isLoading = signal<boolean>(false);
  params = {
    limit: 10,
    offset: 0,
  };

  private BaseService = inject(BaseService);
  private message = inject(NzMessageService);

  ngOnInit(): void {
    this.getDeliveryHistory();
  }

  getDeliveryHistory() {
    if (this.isLoading()) return;
    this.isLoading.set(true);

    this.BaseService.getData(QRISLY_DELIVERY_HISTORY, this.params).subscribe((res: { data: DeliveryWebhookResponse }) => {
      this.deliveryHistory = {
        ...res.data,
        list: this.params.offset === 0
          ? (res.data?.list || [])
          : [...(this.deliveryHistory?.list || []), ...(res.data?.list || [])]
      };
      this.isLoading.set(false);
    }, (err) => {
      this.message.error(err.error.meta.message || 'Failed to get delivery history');
      this.isLoading.set(false);
    });
  }

  onScroll(): void {
    if (this.isLoading() || this.deliveryHistory.list.length < (this.params.offset + this.params.limit)) {
      return;
    }

    if (this.deliveryHistory.list.length >= this.deliveryHistory.total) {
      return;
    }

    this.params.offset += this.params.limit;
    this.getDeliveryHistory();
  }

  sortByDate(a: DeliveryWebhookResponseList, b: DeliveryWebhookResponseList) {
    return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
  }

  handleClassStatus(status: string): string {
    if (status === 'success') {
      return 'status-success';
    }
    if (status === 'failed' || status === 'expired') {
      return 'status-danger';
    }
    return 'status-warning';
  }

  handleResendWebhook(historyId: string) {
    this.isLoading.set(true);
    this.BaseService.putData(QRISLY_RESEND_WEBHOOK + `/${historyId}`, {}).subscribe((res: ResponseCustomType<null>) => {
      this.message.success(res.meta.message);
      this.params.offset = 0;

      setTimeout(() => {
        this.isLoading.set(false);
        this.getDeliveryHistory();
      }, 1500);
    }, (err) => {
      this.isLoading.set(false);
      this.message.error(err.error.meta.message || 'Failed to resend webhook');
    });
  }

}
